
import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-apps',
  templateUrl: './apps.component.html',
  styleUrl: './apps.component.scss'
})
export class AppsComponent implements OnInit {

  apps: {
    title: string;
    route: string;
    svg: SafeHtml;
  }[] = [];

  constructor(private sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    this.apps = [
      { title: 'Urology', route: '/forms/urology', svg: this.safe(this.urologySvg) },
      { title: 'Dermatology', route: '/forms/dermatology', svg: this.safe(this.dermatologySvg) },
      { title: 'Cosmetic', route: '/forms/cosmetic', svg: this.safe(this.cosmeticSvg) },
      { title: 'ENT', route: '/forms/ent', svg: this.safe(this.entSvg) },
      { title: 'Gynecology', route: '/forms/gynecology', svg: this.safe(this.gynecologySvg) },
      { title: 'Dentistry', route: '/dentist', svg: this.safe(this.dentistSvg) },
      { title: 'Neurology', route: '/forms/neurology', svg: this.safe(this.neurologySvg) },
      { title: 'Physiotherapy', route: '/forms/physiotherapy', svg: this.safe(this.physiotherapySvg) },
      { title: 'Internal Medicine', route: '/forms/internal', svg: this.safe(this.internalSvg) },
      { title: 'Orthopedics', route: '/forms/orthopedics', svg: this.safe(this.orthopedicsSvg) },
    ];
  }

  safe(svg: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(svg);
  }

  // =========================
  // SVG ICONS
  // =========================

  urologySvg = `
  				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width="80"
											height="80" fill="none" stroke="#009688" stroke-width="2"
											stroke-linecap="round" stroke-linejoin="round">
											<!-- Kidneys -->
											<path
												d="M16 20c-6 0-10 6-10 12s4 12 10 12c3 0 6-2 7-5l3-7-3-7c-1-3-4-5-7-5z"
												fill="#b2dfdb" />
											<path
												d="M48 20c6 0 10 6 10 12s-4 12-10 12c-3 0-6-2-7-5l-3-7 3-7c1-3 4-5 7-5z"
												fill="#b2dfdb" />

											<!-- Ureters -->
											<path d="M23 32v12c0 4 3 6 6 6h6c3 0 6-2 6-6V32" stroke="#00796b" />

											<!-- Bladder -->
											<path d="M22 50c0 6 5 10 10 10s10-4 10-10" fill="#80cbc4"
												stroke="#00796b" />
											<path d="M24 58c4 3 12 3 16 0" stroke="#00796b" />
										</svg>`;

  dermatologySvg = `
 					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width="80"
											height="80" fill="none" stroke="#009688" stroke-width="2"
											stroke-linecap="round" stroke-linejoin="round">
											<!-- Face outline -->
											<path
												d="M32 6c-8 0-14 6-14 14v6c0 6-2 10-6 14 4 4 6 8 6 14v6c0 8 6 14 14 14s14-6 14-14v-6c0-6 2-10 6-14-4-4-6-8-6-14v-6c0-8-6-14-14-14z"
												fill="#b2dfdb" />

											<!-- Spots / skin marks -->
											<circle cx="26" cy="28" r="1.5" fill="#00796b" />
											<circle cx="38" cy="30" r="1.5" fill="#00796b" />
											<circle cx="30" cy="36" r="1.5" fill="#00796b" />

											<!-- Hand / treatment -->
											<path d="M42 46c2 0 4 2 6 4 1 1 2 2 2 3 0 2-2 3-4 3H32" stroke="#00796b" />

											<!-- Cream bottle -->
											<rect x="10" y="44" width="6" height="12" fill="#80cbc4" stroke="#00796b" />
											<rect x="11" y="42" width="4" height="2" fill="#00796b" />
										</svg>`;

  cosmeticSvg = `
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width="80"
											height="80" fill="none" stroke="#009688" stroke-width="2"
											stroke-linecap="round" stroke-linejoin="round">
											<!-- Face outline -->
											<path
												d="M32 6c-8 0-14 6-14 14v6c0 6-2 10-6 14 4 4 6 8 6 14v6c0 8 6 14 14 14s14-6 14-14v-6c0-6 2-10 6-14-4-4-6-8-6-14v-6c0-8-6-14-14-14z"
												fill="#b2dfdb" />

											<!-- Syringe (cosmetic injection) -->
											<line x1="42" y1="20" x2="54" y2="8" stroke="#00796b" />
											<rect x="52" y="6" width="4" height="8" rx="1" ry="1" fill="#80cbc4"
												stroke="#00796b" />
											<line x1="44" y1="18" x2="48" y2="22" stroke="#00796b" />

											<!-- Lips -->
											<path d="M26 38c2 2 8 2 12 0" stroke="#00796b" fill="none" />
											<path d="M26 38c2-3 10-3 12 0" stroke="#00796b" fill="none" />

											<!-- Sparkles (beauty glow) -->
											<path d="M18 18l1 2 2 1-2 1-1 2-1-2-2-1 2-1 1-2z" stroke="#00796b" />
											<path d="M46 46l1 2 2 1-2 1-1 2-1-2-2-1 2-1 1-2z" stroke="#00796b" />
										</svg>`;

  entSvg = `
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width="80"
											height="80" fill="none" stroke="#009688" stroke-width="2"
											stroke-linecap="round" stroke-linejoin="round">
											<!-- Ear -->
											<path
												d="M18 22c0-6 4-10 10-10s10 4 10 10c0 4-3 7-5 9-2 2-2 4-2 6 0 3-2 5-5 5s-5-2-5-5"
												fill="#b2dfdb" />

											<!-- Nose -->
											<path d="M34 12c3 6 2 14 0 18-2 4-2 8 2 12 3 3 3 8-3 8" stroke="#00796b" />

											<!-- Throat -->
											<path d="M30 50c0 6 4 8 8 8s8-2 8-8" fill="#80cbc4" stroke="#00796b" />

											<!-- Sound waves (for hearing) -->
											<path d="M12 22c-2 2-3 4-3 6s1 4 3 6" stroke="#00796b" />
											<path d="M8 20c-3 3-4 6-4 8s1 5 4 8" stroke="#00796b" />
										</svg>
`;

  gynecologySvg = `
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width="80"
											height="80" fill="none" stroke="#009688" stroke-width="2"
											stroke-linecap="round" stroke-linejoin="round">
											<!-- Woman body outline / pregnancy silhouette -->
											<path
												d="M32 6c-6 0-10 4-10 10v6c0 4-1 8-4 12 3 4 4 8 4 12v6c0 6 4 10 10 10s10-4 10-10v-6c0-4 1-8 4-12-3-4-4-8-4-12v-6c0-6-4-10-10-10z"
												fill="#b2dfdb" />

											<!-- Baby belly circle -->
											<circle cx="32" cy="38" r="6" fill="#80cbc4" stroke="#00796b" />
											<circle cx="34" cy="38" r="2" fill="#00796b" />

											<!-- Heart inside belly -->
											<path
												d="M30 40c1 1 2 2 2 2s1-1 2-2c1-1 1-2 0-3-1-1-2 0-2 1 0-1-1-2-2-1-1 1-1 2 0 3z"
												fill="#e57373" stroke="#00796b" />

											<!-- Soft sparkles -->
											<path d="M18 18l1 2 2 1-2 1-1 2-1-2-2-1 2-1 1-2z" stroke="#00796b" />
											<path d="M46 46l1 2 2 1-2 1-1 2-1-2-2-1 2-1 1-2z" stroke="#00796b" />
										</svg>`;

  dentistSvg = `
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width="80"
											height="80" fill="none" stroke="#009688" stroke-width="2"
											stroke-linecap="round" stroke-linejoin="round">
											<!-- Tooth shape -->
											<path
												d="M32 6c-6 0-12 4-14 10-2 6 0 14 2 22s4 14 6 18c1 2 2 2 4 2s3 0 4-2c2-4 4-10 6-18s4-16 2-22c-2-6-8-10-14-10z"
												fill="#b2dfdb" stroke="#009688" />

											<!-- Inner shine -->
											<path d="M26 16c2-2 6-2 8 0" stroke="#00796b" />
											<path d="M24 20c3-2 9-2 12 0" stroke="#00796b" />

											<!-- Sparkles for cleanliness -->
											<path d="M16 22l1 2 2 1-2 1-1 2-1-2-2-1 2-1 1-2z" stroke="#00796b" />
											<path d="M46 18l1 2 2 1-2 1-1 2-1-2-2-1 2-1 1-2z" stroke="#00796b" />

											<!-- Dental mirror tool -->
											<line x1="50" y1="40" x2="58" y2="48" stroke="#00796b" />
											<circle cx="58" cy="48" r="3" stroke="#00796b" fill="#80cbc4" />
										</svg>`;

  neurologySvg = `
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width="80"
											height="80" fill="none" stroke="#009688" stroke-width="2"
											stroke-linecap="round" stroke-linejoin="round">
											<!-- Brain container -->
											<path
												d="M24 10c-5 0-9 4-9 9 0 1 .1 2 .4 3C12 24 10 26 10 29c0 3 2 5 4 6-.6 1.2-1 2.6-1 4 0 4 3 7 7 7h4"
												fill="#b2dfdb" />
											<path
												d="M40 10c5 0 9 4 9 9 0 1-.1 2-.4 3 3 2 5 4 5 7 0 3-2 5-4 6 .6 1.2 1 2.6 1 4 0 4-3 7-7 7h-4"
												fill="#b2dfdb" />
											<!-- Brain outline -->
											<path
												d="M24 10c-5 0-9 4-9 9 0 1 .1 2 .4 3C12 24 10 26 10 29c0 3 2 5 4 6-.6 1.2-1 2.6-1 4 0 4 3 7 7 7h4M40 10c5 0 9 4 9 9 0 1-.1 2-.4 3 3 2 5 4 5 7 0 3-2 5-4 6 .6 1.2 1 2.6 1 4 0 4-3 7-7 7h-4" />
											<!-- Gyri/sulci -->
											<path
												d="M22 18c2-2 6-2 8 0M18 24c3-2 9-2 12 0M18 31c2 1 5 1 7 0M34 18c2-2 6-2 8 0M34 24c3-2 9-2 12 0M39 31c2 1 5 1 7 0"
												stroke="#00796b" />
											<!-- Brain stem / spinal hint -->
											<path d="M31 46v4c0 2 2 4 4 4" stroke="#00796b" />
											<!-- Neuron symbol -->
											<circle cx="32" cy="36" r="3" fill="#80cbc4" stroke="#00796b" />
											<path
												d="M32 33v-3M32 39v3M29 36h-3M35 36h3M30.5 33.5l-2-2M33.5 33.5l2-2M30.5 38.5l-2 2M33.5 38.5l2 2"
												stroke="#00796b" />
										</svg>`;

  physiotherapySvg = `
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width="80"
											height="80" fill="none" stroke="#009688" stroke-width="2"
											stroke-linecap="round" stroke-linejoin="round" aria-labelledby="title desc"
											role="img">
											<title id="title">Physiotherapy Icon</title>
											<desc id="desc">Stylized person stretching with spine curve and supportive
												hand</desc>

											<!-- Supportive hand base -->
											<path
												d="M10 46c4-2 8-3 12-3h10c3 0 6 1 9 2l9 3c2 .7 3 2.5 3 4.3 0 1.6-1.3 2.7-2.8 2.2L44 52"
												fill="#b2dfdb" />

											<!-- Person (head + torso/arms/leg in a stretch pose) -->
											<circle cx="28" cy="18" r="4" fill="#b2dfdb" stroke="#00796b" />
											<path d="M26 22l-4 6m6-6l6 5" stroke="#00796b" />
											<path d="M28 26c0 4-1 8-3 12" stroke="#00796b" />
											<path d="M25 38l-6 8M32 31l7 3" stroke="#00796b" />

											<!-- Spine curve with markers -->
											<path d="M40 14c6 6 8 16 3 24" />
											<path d="M40 18h0M41.5 22h0M42.5 26h0M42 30h0M41 34h0" stroke="#00796b" />

											<!-- Therapeutic leaf/care motif -->
											<path d="M14 40c4-5 10-7 16-6-2 6-8 10-16 10" fill="#b2dfdb" />
										</svg>`;

  internalSvg = `
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width="80"
											height="80" fill="none" stroke="#009688" stroke-width="2"
											stroke-linecap="round" stroke-linejoin="round" aria-labelledby="title desc"
											role="img">
											<title id="title">Endometrium / باطنة الرحم</title>
											<desc id="desc">Uterus with highlighted inner lining to represent
												endometrium/endometriosis</desc>

											<!-- Uterus outer outline -->
											<path d="M20 20c-4 0-8 3-8 7 0 4 3 7 7 7h3" />
											<path d="M44 20c4 0 8 3 8 7 0 4-3 7-7 7h-3" />
											<path d="M24 34c2 6 1 12-1 18M40 34c-2 6-1 12 1 18" />
											<path d="M24 34c4-2 12-2 16 0" />
											<path d="M23 52c3 2 15 2 18 0" />

											<!-- Ovaries -->
											<circle cx="12" cy="27" r="3" fill="#b2dfdb" stroke="#00796b" />
											<circle cx="52" cy="27" r="3" fill="#b2dfdb" stroke="#00796b" />

											<!-- Fallopian curves -->
											<path d="M20 21c-3 1-6 3-8 6" stroke="#00796b" />
											<path d="M44 21c3 1 6 3 8 6" stroke="#00796b" />

											<!-- Inner uterus cavity -->
											<path
												d="M26 22c4-2 8-2 12 0 3 2 4 6 3 10-1 4-4 6-9 6s-8-2-9-6c-1-4 0-8 3-10z"
												stroke="#00796b" fill="none" />

											<!-- Highlighted endometrial lining -->
											<path d="M28 24c3-1 5-1 8 0 2 1 3 4 2 7-1 3-3 4-6 4s-5-1-6-4c-1-3 0-6 2-7z"
												fill="#b2dfdb" stroke="#00796b" />

											<!-- Small lesion dots to suggest endometriosis if needed -->
											<circle cx="31" cy="31" r="0.9" fill="#00796b" />
											<circle cx="35" cy="29" r="0.9" fill="#00796b" />
											<circle cx="33" cy="33" r="0.9" fill="#00796b" />
										</svg>`;

  orthopedicsSvg = `
 		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width="80"
											height="80" fill="none" stroke="#009688" stroke-width="2"
											stroke-linecap="round" stroke-linejoin="round" aria-labelledby="title desc"
											role="img">
											<title id="title">Orthopedics / عظام</title>
											<desc id="desc">Stylized long bone with joint to represent orthopedics
											</desc>

											<!-- Long bone shaft -->
											<path d="M26 18c2.5 2.5 3.2 6.3 1.6 9.3L20 39.5c-1.6 3-0.9 6.8 1.6 9.3" />

											<!-- Joint (proximal head) -->
											<path
												d="M26 18c-1.8-1.8-1.9-4.7-0.1-6.5 1.8-1.8 4.7-1.8 6.5 0 1.3-1.3 3.4-1.7 5.1-0.8 2.2 1.2 3 3.9 1.8 6.1-0.6 1.1-1.6 2.0-2.8 2.4-3.6 1.2-7.2 1.2-10.5-1.2z"
												fill="#b2dfdb" stroke="#00796b" />

											<!-- Distal end / joint surfaces -->
											<path
												d="M21.6 48.8c1.1 1.1 2.6 1.7 4.1 1.7 1.6 0 3.1-0.6 4.2-1.8 0.8-0.8 1.9-1.2 3-1.2 1.1 0 2.2 0.4 3 1.2 2.3 2.3 6.1 2.3 8.4 0s2.3-6.1 0-8.4"
												fill="none" stroke="#00796b" />

											<!-- Articular highlight curve -->
											<path d="M36 23c3.5 0.3 6.7-0.2 9.5-1.4" stroke="#00796b" />

											<!-- Small fracture indicator (subtle, optional) -->
											<path d="M24 34l3 2M23 36l3 2" stroke="#00796b" />
										</svg>`;
}
